import { getTimestamp, findDependants, getTimestampForMessage } from './helpers';
import { postAnswer } from '@assessment/../api/answer';
import { logAsDelivered } from '@assessment/../api/log';
export default {
  namespaced: true,

  state: {
    messages: [],
    deliveredMessages: [],
    messagesCompleted: false,
  },

  actions: {
    DELIVER_MESSAGES: async ({ rootState, rootGetters, commit }, messagesToDeliver) => {
      // temporary 'allowReEntryInbox' logic for next sprint
      const { allowReEntryInbox } = rootState.versionConfig;
      const simsettings = rootState.simsettings;
      const isSimReEntry =
        simsettings !== null &&
        Object.keys(simsettings).length > 0 &&
        simsettings.allowReEntryInbox !== undefined;
      const allowReEntry = allowReEntryInbox || isSimReEntry;
      messagesToDeliver.forEach((message) => {
        message.timestamp = getTimestampForMessage(
          rootGetters.showTimerAsClock,
          rootGetters['time/clockTimer'],
          allowReEntry
        );
        message.isDelivered = true;
      });

      if (rootGetters['assessmentType'].isWebApp) {
        const messagesToDeliverKeys = messagesToDeliver.map((message) => {
          return {
            questionKey: message.questionKey,
            isAutoDelivered: message.isAutoDelivered ? message.isAutoDelivered : 0,
          };
        });
        await logAsDelivered({ deliveredKeys: messagesToDeliverKeys, logActionTypeKey: 15 });
      }

      commit('DELIVER_MESSAGES', messagesToDeliver);
    },

    ANSWER_MESSAGE: async (
      { commit, rootGetters, getters, rootState },
      { questionkey, answerkey, isMessage, writtenResponse }
    ) => {
      if (rootState['assessmentTypeKey'] === 1) {
        await postAnswer({ answerkey, questionkey, isMessage, writtenResponse });
      }
      const answers = typeof answerkey == 'object' ? answerkey : [answerkey];
      const dependantEmails = findDependants(rootGetters['email/threadEmails'], answers);
      const dependantMessages = findDependants(getters.messagesFromThread, answers);

      //Add dependant emails to active emails
      commit(
        'email/SET_DEPENDANT',
        {
          dependantEmails,
          rootGetters,
          time: { minutes: rootState.time.minutes, hour: rootState.time.hour },
        },
        { root: true }
      );
      //Add dependant messages to queue
      commit('SET_DEPENDANT', { dependantMessages, rootGetters });
      commit('ANSWER_MESSAGE', { questionkey, answerkey, rootGetters, writtenResponse });
    },
  },

  mutations: {
    ANSWER_MESSAGE: (state, { questionkey, answerkey, rootGetters, writtenResponse }) => {
      const message = state.messages.find((question) => question.questionKey === questionkey);
      let answers = typeof answerkey == 'object' ? answerkey : [answerkey];

      if (message.FK_questionTypeKey === 3) {
        Vue.set(message, 'writtenResponse', writtenResponse);
      }

      //Set answer picked on question
      Vue.set(
        message,
        'answer',
        message.answers.filter((answer) => answers.includes(answer.answerKey))
      );
      // Vue.set(message, 'answer', message.answers.find( answer => answer.answerKey === answerkey ))
      Vue.set(message, 'isSent', true);
      Vue.set(message, 'isRead', true);
    },

    EXPEDITE_MESSAGE: (state, { message, time }) => {
      // TODO: Refactor this so this retrieves the message from the module state
      Vue.set(message, 'isAutoDelivered', true);
      Vue.set(message, 'timer', time);
    },

    SET_DEPENDANT: (state, { dependantMessages, rootGetters }) => {
      dependantMessages.forEach((messageToPush) => {
        Vue.set(messageToPush, 'timer', messageToPush.timer + rootGetters['time/elapsed']);
        //Vue.delete(messageToPush, 'dependsOn')
        Vue.set(messageToPush, 'dependencies', []);
      });
    },

    SET_MESSAGES: (state, messages) => (state.messages = messages),

    SET_IS_READ: (state, questionKeys) =>
      state.messages.forEach((m) => {
        if (questionKeys.indexOf(m.questionKey) !== -1 && !m.isRead) Vue.set(m, 'isRead', true);
      }),

    DELIVER_MESSAGES: (state, messages) => {
      const newDeliveredMessages = state.deliveredMessages.slice();
      newDeliveredMessages.push(...messages);
      state.deliveredMessages = newDeliveredMessages;
    },
  },

  getters: {
    messages: (state) => state.messages,

    messagesFromThread: (state) => state.messages.filter((m) => m.dependencies.length > 0),

    activeMessages: (state) => state.messages.filter((m) => m.dependencies.length == 0),

    unansweredActiveMessages: (state, getters) => getters.activeMessages.filter((m) => !m.isSent),

    messagesCompleted: (state, getters) =>
      getters.activeMessages
        .filter((m) => m.answers.length > 0)
        .every((m) => m.answer !== undefined),

    deliveredMessages: (state) => state.deliveredMessages,
  },
};
